export default "__VITE_ASSET__BhOksb53__"